import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import { AllLocationResponseModel, CreateLocationsResponseModel,  LocationRequest,  LocationResponse, LocationResponseModel } from '@gtpl/shared-models/masters';
import { ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { Body, Controller, Post ,Headers ,Get } from '@nestjs/common';
import { ApiTags } from '@nestjs/swagger';
import { LocationsDtoActive } from './dto/location-active';
import { LocationsDTO } from './dto/location-dto';
import { LocationByIdDto } from './dto/location_dto';
import { RackZoneRequest } from './dto/rack-zone.request';
import { LocationsService } from './locations.service';
@ApiTags('locations')
@Controller('locations')
export class LocationsController {
    constructor(private locationService: LocationsService,
        private readonly applicationExceptionHandler: ApplicationExceptionHandler) { }
    
      @Post('/createLocations')
      async createLocations(@Body() locationsDto: LocationsDTO): Promise<CreateLocationsResponseModel>  {
        try {
          return await this.locationService.CreateLocations(locationsDto, false);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(CreateLocationsResponseModel, error);
        }
      }
    
    
      @Post('/updateLocations')
      async updateLocations(@Body() locationsDto: LocationsDTO): Promise<CreateLocationsResponseModel>  {
        try {
          return await this.locationService.CreateLocations(locationsDto, true);
        }
    catch (error) {
          return this.applicationExceptionHandler.returnException(CreateLocationsResponseModel, error);
        }
      }
    
    
      @Post('/getRecordByLocationsId')
      async getRecordByLocationsId(@Body() id: LocationByIdDto): Promise<LocationResponseModel> {
        try {
          return await this.locationService.getRecordByLocationsId(id.locationId);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(LocationResponseModel, error);
        }
      }
      @Post('/getAllLocationsByZoneAndRack')
      async getAllLocationsByZoneAndRack(@Body() rackZoneRequest: RackZoneRequest): Promise<LocationResponseModel> {
        try {
          return await this.locationService.getAllLocationsByZoneAndRack(rackZoneRequest);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(LocationResponseModel, error);
        }
      }
      @Post('/getAllLocations')
      async getAllLocations():Promise<AllLocationResponseModel> {
        try {
          return await this.locationService.getAllLocations();
        } catch (error) {
          return this.applicationExceptionHandler.returnException(AllLocationResponseModel, error);
        }
      }
      @Post('/activateorDeactivateLocation')
      async activateorDeactivateLocation(@Body() locationAct: LocationsDtoActive):Promise<LocationResponse> {
        try {
          return await this.locationService.activateorDeactivateLocation(locationAct);
        } catch (error) {
          return this.applicationExceptionHandler.returnException(LocationResponse, error);
        }
      } 
      @Post('getLocationById')
  async getLocationById(@Body() locationRequest: LocationRequest):Promise<LocationResponseModel> {
    console.log(locationRequest);
   try {
      return await this.locationService.getLocationById(locationRequest);
   } catch (error) {
      return this.applicationExceptionHandler.returnException(LocationResponseModel, error);
    }
  }

  @Post('logTemperature')
  async logTemeperaturePost(@Headers() headers: any, @Body() body: any): Promise<any> {
    try {
      return await this.locationService.logTemeperature(JSON.stringify(headers), JSON.stringify(body));
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
    }
  }

  @Get('logTemperature')
  async logTemeperatureGet(@Headers() headers: any, @Body() body: any): Promise<any> {
    try {
      return await this.locationService.logTemeperature(JSON.stringify(headers), JSON.stringify(body));
    } catch (error) {
      return this.applicationExceptionHandler.returnException(GlobalResponseObject, error);
    }
  }

}
